function TermsAndConditions() {
  return (
    <div style={{ maxWidth: 800, margin: '0 auto', padding: '40px 20px', color: '#e4e4e7', fontFamily: 'system-ui, sans-serif', lineHeight: 1.7 }}>
      <h1 style={{ fontSize: 28, marginBottom: 4 }}>Terms and Conditions</h1>
      <p style={{ color: '#71717a', fontSize: 13, marginBottom: 24 }}>Last updated: April 4, 2026</p>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>1. Acceptance of Terms</h2>
        <p>By accessing and using MeWare ("the Application"), you agree to be bound by these Terms and Conditions. If you do not agree to these terms, do not use the Application.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>2. Description of Service</h2>
        <p>MeWare is a personal finance management application that allows you to:</p>
        <ul style={{ paddingLeft: 24 }}>
          <li>Sync and view financial transactions from linked accounts</li>
          <li>Import transactions from CSV files</li>
          <li>Categorize, tag, and manage transactions</li>
          <li>Generate spending reports and financial insights</li>
          <li>Track net worth and account balances</li>
        </ul>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>3. Account and Access</h2>
        <p>Access to the Application requires authentication. You are responsible for maintaining the confidentiality of your login credentials and for all activities that occur under your account.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>4. User Responsibilities</h2>
        <p>You agree to:</p>
        <ul style={{ paddingLeft: 24 }}>
          <li>Provide accurate information when using the Application</li>
          <li>Use the Application only for lawful purposes</li>
          <li>Not attempt to gain unauthorized access to the Application or its systems</li>
          <li>Not interfere with or disrupt the Application's functionality</li>
        </ul>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>5. Financial Data</h2>
        <p>The Application provides tools for managing and viewing your financial data. We do not provide financial advice, and the Application should not be used as a substitute for professional financial guidance. All financial data displayed is for informational purposes only.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>6. Third-Party Integrations</h2>
        <p>The Application integrates with third-party services such as SimpleFIN for account syncing. Your use of these services is subject to their respective terms and conditions. We are not responsible for the availability, accuracy, or security of third-party services.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>7. Limitation of Liability</h2>
        <p>The Application is provided "as is" without warranties of any kind. We are not liable for any direct, indirect, incidental, or consequential damages arising from your use of the Application, including but not limited to:</p>
        <ul style={{ paddingLeft: 24 }}>
          <li>Loss of data or financial information</li>
          <li>Inaccuracies in transaction data or reports</li>
          <li>Service interruptions or downtime</li>
          <li>Actions taken based on information displayed in the Application</li>
        </ul>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>8. Intellectual Property</h2>
        <p>All content, features, and functionality of the Application are owned by MeWare and are protected by applicable intellectual property laws.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>9. Termination</h2>
        <p>We reserve the right to terminate or suspend access to the Application at any time, with or without cause or notice.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>10. Changes to Terms</h2>
        <p>We may revise these Terms and Conditions at any time. Changes will be posted on this page with an updated revision date. Continued use of the Application after changes constitutes acceptance of the revised terms.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>11. Governing Law</h2>
        <p>These Terms and Conditions are governed by and construed in accordance with the laws of the State of Illinois, United States.</p>
      </section>

      <section style={{ marginBottom: 24 }}>
        <h2 style={{ fontSize: 18, marginBottom: 8 }}>12. Contact</h2>
        <p>If you have any questions about these Terms and Conditions, please contact us through the application.</p>
      </section>

      <div style={{ borderTop: '1px solid #2a2b35', paddingTop: 16, marginTop: 32, textAlign: 'center' }}>
        <a href="/" style={{ color: '#8b5cf6', textDecoration: 'none' }}>Back to MeWare</a>
        {' | '}
        <a href="/privacy" style={{ color: '#8b5cf6', textDecoration: 'none' }}>Privacy Policy</a>
      </div>
    </div>
  );
}

export default TermsAndConditions;
